import { Accordion, Container, Row } from "react-bootstrap";
import { PrismicText, PrismicRichText } from "@prismicio/react";
import "./sectionDetail.scss";

const LayoutImagenesIzquierda = ({ slice }) => {

  const img1IsSvg = slice.primary.image_1?.url?.includes('.svg');
  const img2IsSvg = slice.primary.image_2?.url?.includes('.svg');

  return (
    <section className="contenedorServicio col-12">
      <div className="contenedorDisplay">
        <h3><PrismicText field={slice.primary.title} /></h3>
        <div className="contenedorImg">
          {slice.primary.image_1?.url && (
            img1IsSvg ? (
              <img src={slice.primary.image_1.url} alt={slice.primary.image_1.alt || 'img servicio 1'} />
            ) : (
              <div className="img1" style={{ backgroundImage: `url(${slice.primary.image_1.url})` }}></div>
            )
          )}
          {slice.primary.image_2?.url && (
            img2IsSvg ? (
              <img src={slice.primary.image_2.url} alt={slice.primary.image_2.alt || 'img servicio 2'} />
            ) : (
              <div className="img2" style={{ backgroundImage: `url(${slice.primary.image_2.url})` }}></div>
            )
          )}
        </div>
      </div>
      <div className="contenedorTexto">
        {slice.items.map((item, index) => (
          <div className="divTexto" key={index}>
            <h6><PrismicText field={item.item_title} /></h6>
            <PrismicRichText field={item.item_description} />
          </div>
        ))}
      </div>
    </section>
  );
};

const LayoutTarjetasCentradas = ({ slice }) => (
  <section className="contenedorServicio posicionamiento col-12">
    <div className="contenedorTexto">
      <h3><PrismicText field={slice.primary.title} /></h3>
      <PrismicRichText field={slice.primary.main_description} />
    </div>
    <div className="contenedorEtapas">
      <h4><PrismicText field={slice.primary.subtitle} /></h4>
      <Accordion className="contenedorMaster">
        {slice.items.map((item, index) => (
          <Accordion.Item eventKey={index.toString()} className="etapa" key={index}>
            <Accordion.Header className="headerEtapa">
              <h5><PrismicText field={item.item_title} /></h5>
            </Accordion.Header>
            <Accordion.Body className="bodyEtapa">
              <PrismicRichText field={item.item_description} />
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  </section>
);

const LayoutTextoImagen = ({ slice }) => (
  <section className="contenedorServicio callcenter col-12">
    <div className="contenedorTexto">
      <h3><PrismicText field={slice.primary.title} /></h3>
      <PrismicRichText field={slice.primary.main_description} />
      {slice.primary.image_1?.url && (
        <div className="imgSeccionCall" style={{ backgroundImage: `url(${slice.primary.image_1.url})` }}></div>
      )}
    </div>
    <div className="contenedorLista">
      {slice.items.map((item, index) => (
        <div className="lista" key={index}>
          <h5><PrismicText field={item.item_title} /></h5>
          <PrismicRichText field={item.item_description} />
        </div>
      ))}
    </div>
  </section>
);

const DetalleServicio = ({ slice }) => {
  const variacion = slice.primary.variacion || 'Imagenes a la izquierda';

  let LayoutComponent = LayoutImagenesIzquierda;

  if (variacion === 'Tarjetas centradas') {
    LayoutComponent = LayoutTarjetasCentradas;
  } else if (variacion === 'Texto e Imagen a la izquierda') {
    LayoutComponent = LayoutTextoImagen;
  }

  return (
    <div className="serviciosPrincipal">
      <Container>
        <Row>
          <LayoutComponent slice={slice} />
        </Row>
      </Container>
    </div>
  );
};

export default DetalleServicio;
